import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { Button } from 'muicss/react';

import MFAshow from "assets/img/MFA-show.png";

// componenets
import Modal from 'components/Modal';

import { updateMfaAlertedStatus } from "actions/user";

const mfaURL = APP_CONFIG.mfaURL;
const redirectURL = APP_CONFIG.redirectURL;

@connect(state => ({
  user: state.user.get('data'),
}))

class MFACentre extends Component {
  static propTypes = {
    isModalOpen: PropTypes.bool,
    dispatch: PropTypes.func,
    user: PropTypes.object,
  };

  closeModal = () => {
    const { dispatch } = this.props;
  
    dispatch(updateMfaAlertedStatus({ MfaAlertedFlag: true }))
      .catch((error) => {
        console.error("Failed to update MFA alerted status", error);
      });
  };

  enableMfa = () => {
    const {
      dispatch
    } = this.props;
    dispatch(updateMfaAlertedStatus({ MfaAlertedFlag: true }))
    .then(() => {
      window.location.assign(`${mfaURL}&returnTo=${redirectURL}`);
    })
    .catch((error) => {
      console.error("Failed to update MFA alerted status", error);
    });
  }

  renderMfaBody() {
    return (
      <div className={ 'common-overlay-content' }>
        <div className={ 'content-box-wrapper text-center' }>
          <button onClick={() => this.closeModal()} type="button" className="modal-btn-close">
            <span className="icon-cross"></span>
          </button>

          <img src={MFAshow} className={'full-width'}/>
          <div className={'px-25 pb-10'}>
            <h2 className={'common-overlay-header font-bold-family'}>Protect Your Account</h2>
            <p className={'font-16'}>Add an extra layer of security to your account by setting up Multi-Factor Authentication.</p>
            <p className={'font-14 modal-text-description'}>You’ll be directed to a separate screen to set up multi-factor authentication. You can set it up now or do it later in your account settings.</p>

            <div className={'flex-inline flex-inline-col'}>
              <Button onClick={() => this.enableMfa()} className={'mui-btn--success'}>
                Continue
              </Button>
              <Button onClick={() => this.closeModal()} className={'mui-btn--secondary borderless-btn ml-0'}>
                Set Up Later
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }


  render() {
    const { isModalOpen } = this.props;
    return (
      <Modal
        open={ isModalOpen }
        onCloseModal={ this.closeModal }
        contentComponent={ this.renderMfaBody() }
        width={ 'common-small-overlay-body xs-size borderless-space no-header no-footer rounded-corners-16 overflow-y-auto' }
      />
    );
  }
}
export default MFACentre;
